export default __webpack_public_path__ + "static/media/10 Track 10.0d495761.mp3";